import "vuetify/styles";

import { createVuetify } from "vuetify";
import { aliases, fa } from "vuetify/iconsets/fa";
import { vuetifyConfig } from "@bisom/web_package";

// import icons from "@/const/icons";

export default createVuetify({
  defaults: {
    ...vuetifyConfig.default_component,
    VBtn: {
      class: "text-uppercase",
      rounded: "lg",
    },
    VTextarea: {
      variant: "outlined",
      color: "primary",
      density: "compact",
      rounded: "lg",
    },
    VProgressLinear: {
      color: "primary",
    },
    VTable: {
      density: "compact",
      hover: true,
      fixedHeader: true,
      class: "pa-3",
    },
  },

  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          ...vuetifyConfig.theme_light.colors,
          disabled: "#f5f5f5",
          successDark: "#004D40",
          mapSmurColor: "#68bb6b", // Couleur d'affichage sur la map d'un vecteur type SMUR
          report0: "#BDBDBD", // grey
          report1: "#81D4FA", // blue
          report2: "#4CAF50", // green
          report3: "#FFC107", // orange
          report4: "#F44336", // red
        },
      },
      dark: {
        colors: {
          background: "#121212",
          surface: "#212121",
          disabled: "#424242",
          bisom: "#003662",
          // "bisom-darken-1": "#3700B3",
          secondary: "#03DAC6",
          // "secondary-darken-1": "#018786",
          error: "#F44336",
          info: "#ffc107",
          successDark: "#004D40",
          success: "#009688",
          warning: "#ff9b00",
          priorityBlue: "#5588f0",
          blueBtn: "#1E4E74",
          greyBtn: "#a9a9a9",
          primary: "#EEEEEE",
          actionBtn: "#5588F0",
          mapSmurColor: "#68bb6b",
          report0: "#BDBDBD", // grey
          report1: "#81D4FA", // blue
          report2: "#4CAF50", // green
          report3: "#FFC107", // orange
          report4: "#F44336", //red
        },
      },
    },
  },
  icons: {
    defaultSet: "fa",
    aliases: {
      ...aliases,
      ...vuetifyConfig.icons,
    },
    sets: {
      fa,
    },
  },
});
